// Centralized API Configuration
// This ensures all API requests use the correct base URL with /api prefix

import axios from 'axios';

// Get the base URL from environment variable. Empty = same origin (relative /api).
const raw = process.env.REACT_APP_API_URL;
const BASE_URL = (raw !== undefined && raw !== '') ? raw : '';

// Ensure the URL ends with /api (relative '/api' when BASE_URL is empty)
const API_URL = !BASE_URL ? '/api' : (BASE_URL.endsWith('/api') ? BASE_URL : `${BASE_URL}/api`);

// Create axios instance with default configuration

const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token and clinic scope
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Attach clinic scope if present
    try {
      const clinicScope = localStorage.getItem('clinicScope'); // 'all' or clinicId
      if (clinicScope) {
        config.headers['X-Clinic-Scope'] = clinicScope;
      }
    } catch (e) {}
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Ensure the global axios instance also carries the same headers,
// because a number of screens use axios directly
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    try {
      const clinicScope = localStorage.getItem('clinicScope');
      if (clinicScope) {
        config.headers = config.headers || {};
        config.headers['X-Clinic-Scope'] = clinicScope;
      }
    } catch (e) {}
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export { API_URL, apiClient };
export default apiClient;
